import { render, staticRenderFns } from "./monster.vue?vue&type=template&id=124c21ed"
import script from "./monster.vue?vue&type=script&lang=js"
export * from "./monster.vue?vue&type=script&lang=js"
import style0 from "./monster.vue?vue&type=style&index=0&id=124c21ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports